import type { MaterialReceiptRow } from '../../types/api';
import { MaterialReceiptsTable } from '../materialReceiptsShared';

const COLLAPSE_LS_KEY = 'opsai.allReceipts.regulatory.collapsedGroups.v1';

interface Props {
  rows: MaterialReceiptRow[];
  onSaved: (r: MaterialReceiptRow) => void;
  openAce: (r: MaterialReceiptRow) => void;
  showToast?: (m: string) => void;
  loading?: boolean;
}

// Regulatory receipts (job_category === 'R') — same lookup idiom as the
// Proxy/Corp Action/Issuer tab it sits beside (period band, count badge,
// expand-all, search, month grouping), just without the category pills
// since this tab is already scoped to one category.
export function RegulatoryAllReceiptsTable({ rows, onSaved, openAce, showToast, loading }: Props) {
  return (
    <MaterialReceiptsTable
      rows={rows}
      onSaved={onSaved}
      openAce={openAce}
      showToast={showToast}
      collapseStorageKey={COLLAPSE_LS_KEY}
      emptyMessage="No regulatory receipts yet."
      loading={loading}
    />
  );
}
